export const ChebiLink = (chebi) => <a href={"https://www.ebi.ac.uk/chebi/searchId.do?chebiId=CHEBI:" + chebi.value} target="_blank" rel="noopener noreferrer"> {chebi.value} </a>
